<template>
    <!-- Scan QR code popup modal -->
    <v-dialog class="v-dialog" v-model="utils.showPopup" width="450">
        <v-card class="pb-2">
            <div class="p-4 pb-9">
                <div @click="closePopup()" class="closeIcon-container">
                    <img alt="close" class="close-icon" src="/media/misc/close.png">
                </div>
                <div class="col-centered text-center">
                    <div class="custom-title pt-7">Report hash</div>
                    <div class="custom-subheading pt-3" style="width: auto">Simply scan or copy the report hash to verify</div>
                    <div class="reportHash-qrcode mt-10">
                        <qrcode-vue :value="swap.imghash" level="H" size="150"/>
                    </div>
                </div>
                <div class="p-10 pt-5">
                    <div class="OR-line">
                        <div class="OR-Wrap">
                            <div class="OR font-weight-bold">Or</div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <div class="url-container" style="padding-left: 11px;">
                        <input :value="swap.imghash" class="input-Report--hash" disabled>
                        <div @click="copy(swap.imghash)" class="report-hash-copy" v-b-tooltip.hover.top="swap.copy">
                            <img alt="icon" src="/media/misc/content-copy.png" width="15"/>
                        </div>
                    </div>
                </div>
            </div>
        </v-card>
    </v-dialog>
    <!-- Scan QR code popup modal -->
</template>

<script>

   import {bus} from '../../../main';
   import QrcodeVue from 'qrcode.vue'

   export default {
      name: "QrcodePopup",
      data() {
         return {
            utils: {
               showPopup: false
            },
            swap: {
               copy: 'Copy',
               imghash: '',
            }
         }
      },
      components: {
         QrcodeVue
      },
      methods: {
         closePopup() {
            this.utils.showPopup = false;
         },
         copy(val) {
            this.$copyText(val).then((res) => {
               this.swap.copy = 'Copied!';
            }).catch((err) => {
               this.swap.copy = 'Copy failed';
            });
         }
      },
      watch: {
         'swap.copy'() {
            setTimeout(() => {
               this.swap.copy = 'Copy'
            }, 1000);
         }
      },
      mounted() {
         bus.$on('open_qrcode_popup', (data) => {
            this.swap.imghash = data.img_hash;
            this.utils.showPopup = true;
         });
      }
   }
</script>

<style scoped>
    .report-hash-copy {
        cursor: pointer;
    }
</style>